<div class="orders-modal-overlay">
  <div class="orders-modal">
    @if (isLoading()) {
      <div class="loading-overlay">
        <mat-progress-spinner mode="indeterminate" diameter="40" />
      </div>
    }
    <div class="orders-modal__header">
      @switch (dialogData.mode) {
        @case ('view') {
          <h1>
            {{ 'orders.generalInfo.title' | translate }}
            {{ orderItem()?.orderId }}
          </h1>
        }
      }
      <button class="orders-modal__header-close" (click)="onClose()">
        <app-icon class="orders-modal__header-cross-icon" [icon]="iconName.CLOSE" />
      </button>
    </div>

    @if (dialogData.mode === 'view') {
      <app-tabs [tabs]="tabs" [(activeTab)]="activeTab" [fullWidth]="true" [centered]="true" />
    }
    
    <div class="orders-modal__body">
      @switch (activeTab()) {
        @case ('general') {
          <app-order-general-info [item]="orderItem()" />
        }
        @case ('history') {
          @if (orderItem()?.orderId) {
            <app-order-status-history [orderId]="orderItem()!.orderId" />
          }
        }
      }
    </div>

    @if (!isLoading()) {
      <div class="orders-modal__footer">
        @switch (dialogData.mode) {
          @case ('view') {
            <button class="orders-modal__footer--primary-btn close" (click)="onClose()">
              {{ 'inventory.buttons.close' | translate }}
            </button>
          }
        }
      </div>
    }
  </div>
</div>
